module.exports = __webpack_public_path__ + "img/img19.2f3df804.svg";